import { differenceInCalendarDays, format } from 'date-fns';
import { it } from 'date-fns/locale';

type TDaySeparatorLabels = {
    today: string;
    yesterday: string;
};

export const formatChatDaySeparator = (
    date: Date,
    labels: TDaySeparatorLabels,
    now: Date = new Date(),
): string => {
    const daysAgo = differenceInCalendarDays(now, date);
    if (daysAgo <= 0) return labels.today;
    if (daysAgo === 1) return labels.yesterday;
    return format(date, 'd MMMM yyyy', { locale: it });
};
